import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import { DepartmentCard } from "../cards/DepartmentCard";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useDivisionTableStyles = makeThemedStyles("StrategyTable", (theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: "20px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "center",
  },
  leftTitle: {
    width: "150px",
  },
  cell: {
    width: "250px",
  },
}));

const DivisionGrid = (props: {
  elements: ICardElementWithChildren[];
  onSelect?: (el: ICardElementWithChildren) => void;
}) => {
  const { elements: data } = props;
  const styles = useDivisionTableStyles();

  return (
    <>
      <div className={styles.root} key={`DivisionTable${data?.[0]?.id}`}>
        <div className={styles.row}>
          {data?.map((el) => {
            return (
              <div className={styles.cell} key={el.id}>
                <DepartmentCard
                  typenames={[
                    {
                      name: "Scorecard",
                      title: "Department(s)",
                    },
                  ]}
                  element={el}
                  onSelect={() => {
                    if (props.onSelect) {
                      props.onSelect(el);
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default DivisionGrid;
